<div class="login-cover">
    <div class="login-cover-image" [ngStyle]="{ 'background-image': 'url(' + this.bg + ')' }"></div>
    <div class="login-cover-bg"></div>
</div>

<!-- begin login -->
<div class="login login-v2" data-pageload-addclass="animated fadeIn">
    <!-- begin brand -->
    <div class="login-header">
        <div class="brand">
            <img src="/assets/icon.ico" width="30px" height="30px" class="mr-2" alt=""> <b>Jpos 2021</b>
            <small>ระบบ POS Online</small>
        </div>
        <div class="icon">
            <i class="fa fa-lock"></i>
        </div>
    </div>
    <!-- end brand -->
    <!-- begin login-content -->
    <div class="login-content">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="margin-bottom-0">
            <div class="form-group m-b-20">
                <input type="text" class="form-control form-control-lg" placeholder="Username" formControlName="username" required  id="username"/>
            </div>
            <div class="form-group m-b-20">
                <input type="password" class="form-control form-control-lg" placeholder="Password" formControlName="password" required id="password" />
            </div>
            <div class="login-buttons">
                <button type="submit" class="btn btn-success btn-block btn-lg" id="submit">เข้าระบบ</button>
            </div>

            <div style="margin-top: 20px; padding: 10px; background-color: white; color: black;">
                <a href="https://jpos2.com/jpos2021" style="color: red;">
                    <div>***</div>
                    <div>หากเข้าระบบไม่ได้</div> 
                    <div>ให้คลิกที่นี่แล้วลองทำการ Login อีกรอบ</div> 
                    <div>***</div> 
                </a>
            </div>
        </form>
    </div>
    <!-- end login-content -->
</div>
<!-- end login -->

<ul class="login-bg-list clearfix">
    <li *ngFor="let list of bgList" [ngClass]="{ 'active': list.active }">
        <a href="javascript:;" (click)="changeBg(list)" [ngStyle]="{ 'background-image': 'url(' + list.bg + ')' }"></a>
    </li>
</ul>
